import fetch from 'auth/FetchInterceptor';
import { env } from 'configs/EnvironmentConfig';

const AuthService = {};

AuthService.verifyStatus = function () {
  return fetch({
    method: 'post',
    url: env.API_ENDPOINT_URL + '/auth/status',
    data: {},
    withCredentials: true,
  });
};

export default AuthService;
